const { screens } = require("tailwindcss/defaultTheme")
const headingSizes = {
  "18": ["18px", "21px"],
  "20": ["20px", "24px"],
  "24": ["24px", "28px"],
  "36": ["32px", "38px"],
  "48": ["48px", "57px"],
  "96": ["96px", "144px"],
}

const bodySizes = {
  "12": ["12px", "14px"],
  "14": ["14px", "24px"],
  "18": ["18px", "21px"],
  "20": ["20px", "30px"],
  "24": ["24px", "42px"],
}

function createPrefixedSizes(prefix, sizes) {
  return Object.fromEntries(
    Object.entries(sizes).map(([key, value]) => [`${prefix}-${key}`, value])
  )
}

const withDefault = defaultFont => fonts => [...fonts, defaultFont]
const withSansSerif = withDefault("sans-serif")
const withSerif = withDefault("serif")

const fonts = {
  rubik: {
    heading: withSansSerif(["Rubik"]),
    body: withSansSerif(["Karla"]),
  },
  ibmPlex: {
    heading: withSansSerif(["IBM Plex Sans"]),
    body: withSerif(["IBM Plex Serif"]),
  },
  spectral: {
    heading: withSerif(["Spectral"]),
    body: withSansSerif(["Karla"]),
  },
  merriweather: {
    heading: withSansSerif(["Merriweather Sans"]),
    body: withSerif(["Merriweather"]),
  },
  playfair: {
    heading: withSerif(["Playfair Display"]),
    body: withSansSerif(["Open Sans"]),
  },
  ptSerif: {
    heading: withSerif(["PT Serif"]),
    body: withSansSerif(["Open Sans"]),
  },
}

module.exports = {
  purge: ["./src/**/*.js", "./src/**/*.jsx", "./src/**/*.ts", "./src/**/*.tsx"],
  theme: {
    aspectRatio: {
      none: 0,
      "product-thumbnail": [200, 200],
      "product-image": [80, 107],
      "grid-pane-image": [64, 41],
    },
    fontFamily: {
      ...fonts.playfair,
    },
    extend: {
      colors: {
        primary: "#008000",
        gray: {
          "900": "#262626",
          "800": "#404040",
          "700": "#737373",
          "500": "#8C8C8C",
          "300": "#BFBFBF",
          "200": "#C4C4C4",
          "100": "#D9D9D9",
        },
      },
      backgroundColor: {
        input: "#F3F3F3",
        section: "#F9F9F9",
      },
      spacing: {
        "2.5": "0.625rem",
        "6.25": "1.625rem",
        "7.5": "1.875rem",
        "9": "2.25rem",
        "18": "4.5rem",
      },
      width: {
        avatar: "7.0625rem",
      },
      height: {
        avatar: "7.0625rem",
      },
      maxHeight: {
        hero: "1080px",
      },
      fontSize: {
        base: ["16px", "24px"],
        ...createPrefixedSizes("heading", headingSizes),
        ...createPrefixedSizes("body", bodySizes),
      },
      borderColor: theme => ({
        default: theme("colors.gray.500"),
      }),
      boxShadow: {
        header: "1px 3px 4px rgba(0, 0, 0, 0.2)",
      },
      opacity: {
        "5": "0.05",
        "10": "0.1",
        "90": "0.9",
      },
      borderRadius: {
        default: "0.125rem",
        xl: "0.85rem",
      },
      screens: theme => ({
        "full-carousel": [{ min: "920px", max: screens.lg }, { min: "1570px" }],
      }),
    },
  },
  variants: {
    zIndex: ["responsive", "hover"],
  },
  plugins: [require("tailwindcss-aspect-ratio")],
  corePlugins: {
    container: false,
  },
}
